(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[0,0,1620,1021],[0,1023,1620,1021]]},
		{name:"index_atlas_2", frames: [[516,204,53,75],[0,575,282,49],[726,0,103,49],[714,51,89,49],[650,153,118,49],[516,51,196,49],[506,575,212,49],[516,102,193,49],[284,575,220,49],[516,153,132,49],[516,0,208,49],[711,102,89,49],[0,0,514,573]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_29 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_28 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_27 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_26 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_25 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_24 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_23 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_22 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_21 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_20 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_19 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_18 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_17 = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.bgCapa = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Bitmap2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.zoom_white = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#424154").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#424154").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#424154").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_white, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.zoom_brack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#000000").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#000000").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#000000").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_brack, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,540.0009,1,1.08);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,2,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#D4CFC4").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#F1CB8A").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-1,0,1922,2), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#B4B0BF","#9881D1"],[0,1],-960,0,960,0).beginStroke().moveTo(-960,2).lineTo(-960,-2).lineTo(960,-2).lineTo(960,2).closePath();
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1920,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#B4B0BF").setStrokeStyle(2,1,1).moveTo(400,0).lineTo(-400,0);
	this.shape.setTransform(700,60);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#9881D1").setStrokeStyle(2,1,1).moveTo(300,0).lineTo(-300,0);
	this.shape_1.setTransform(300,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 314;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.ClipGroup_58 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(128.8,9.7).curveTo(128,9.5,127.4,8.7).curveTo(126.8,8,126.5,6.8).curveTo(126.2,5.7,126.2,3.9).curveTo(126.2,2.5,125.9,1.8).curveTo(125.7,1.1,125.2,0.8).curveTo(124.7,0.5,124,0.4).lineTo(122.3,0.3).lineTo(120.9,0.3).lineTo(120.9,8.3).lineTo(122.7,8.3).lineTo(122.7,9.6).lineTo(115.2,9.6).lineTo(115.2,8.3).lineTo(117,8.3).lineTo(117,-8.4).lineTo(115.2,-8.4).lineTo(115.2,-9.7).lineTo(122.5,-9.7).curveTo(125.7,-9.7,127.5,-8.5).curveTo(129.6,-7.2,129.6,-4.5).curveTo(129.6,-2.3,128,-1.1).lineTo(127.1,-0.3).curveTo(127.4,-0.3,128.7,0.7).curveTo(130.4,2.1,130.4,5.1).lineTo(130.5,7.2).curveTo(130.6,8,130.8,8.2).curveTo(131,8.5,131.4,8.5).lineTo(131.5,8.5).lineTo(132.4,7.3).lineTo(133.3,8.4).curveTo(132.5,9.4,132,9.7).curveTo(131.6,9.9,130.8,9.9).curveTo(129.6,9.9,128.8,9.7).closePath().moveTo(120.9,-1).lineTo(122.9,-1).curveTo(125.6,-1,125.6,-4.5).lineTo(125.5,-6).curveTo(125.3,-6.8,125,-7.3).curveTo(124.7,-7.8,124.1,-8.1).curveTo(123.6,-8.4,122.5,-8.4).lineTo(120.9,-8.4).closePath().moveTo(139.1,9.1).curveTo(137.2,8.3,135.9,6.8).curveTo(134.6,5.4,133.9,3.6).curveTo(133.3,2,133.3,-0).curveTo(133.3,-2.1,133.9,-3.7).curveTo(134.6,-5.5,135.9,-6.9).curveTo(137.2,-8.4,139.1,-9.1).curveTo(140.8,-9.9,142.9,-9.9).lineTo(144.8,-9.7).lineTo(147.2,-9).lineTo(147.9,-8.9).lineTo(148.2,-8.9).lineTo(148.6,-9.6).lineTo(149.9,-9.6).lineTo(149.9,-2.8).lineTo(148.5,-2.8).lineTo(148.3,-3.3).curveTo(148.1,-4.4,147.7,-5.2).curveTo(147.3,-6.2,146.6,-7).curveTo(146,-7.7,145.1,-8.2).curveTo(144.2,-8.6,142.9,-8.6).curveTo(141.4,-8.6,140.4,-7.9).curveTo(139.3,-7.2,138.6,-6).curveTo(137.9,-4.6,137.6,-3.2).curveTo(137.3,-1.8,137.3,-0).curveTo(137.3,1.7,137.6,3.1).curveTo(137.9,4.7,138.6,5.9).curveTo(139.2,7.1,140.4,7.9).curveTo(141.4,8.5,142.9,8.5).curveTo(145.1,8.5,146,7.2).curveTo(147,5.9,147,2.9).lineTo(147,2.4).lineTo(143.5,2.4).lineTo(143.6,1.1).lineTo(152.3,1.1).lineTo(152.3,2.4).lineTo(150.5,2.4).lineTo(150.5,9).curveTo(149.4,8.1,149.2,8).lineTo(148.6,7.9).curveTo(148.1,7.9,147.3,8.4).lineTo(146.2,9.1).lineTo(144.8,9.6).curveTo(144.1,9.8,142.9,9.8).curveTo(140.9,9.8,139.1,9.1).closePath().moveTo(-35.5,9.1).curveTo(-37.3,8.3,-38.7,6.8).curveTo(-39.9,5.5,-40.6,3.6).curveTo(-41.3,1.8,-41.3,-0).curveTo(-41.3,-1.9,-40.6,-3.7).curveTo(-39.9,-5.6,-38.7,-6.9).curveTo(-37.2,-8.4,-35.5,-9.1).curveTo(-33.7,-9.9,-31.6,-9.9).curveTo(-29.5,-9.9,-27.7,-9.1).curveTo(-25.9,-8.4,-24.5,-6.9).curveTo(-23.2,-5.5,-22.6,-3.7).curveTo(-21.9,-2.1,-21.9,-0).curveTo(-21.9,2,-22.6,3.6).curveTo(-23.2,5.4,-24.5,6.8).curveTo(-25.8,8.2,-27.7,9.1).curveTo(-29.5,9.8,-31.6,9.8).curveTo(-33.7,9.8,-35.5,9.1).closePath().moveTo(-36,-5.8).curveTo(-36.6,-4.4,-36.8,-3.7).curveTo(-37,-2.7,-37.1,-1.7).lineTo(-37.2,-0).curveTo(-37.2,1.7,-36.9,3.1).curveTo(-36.6,4.7,-35.9,5.9).curveTo(-35.3,7.1,-34.1,7.9).curveTo(-33.1,8.5,-31.6,8.5).curveTo(-30,8.5,-29,7.9).curveTo(-27.9,7.1,-27.3,5.9).curveTo(-26.6,4.7,-26.3,3.1).curveTo(-25.9,1.7,-25.9,-0).lineTo(-26,-1.7).curveTo(-26.1,-2.7,-26.4,-3.7).curveTo(-26.7,-4.9,-27.2,-5.8).curveTo(-28.7,-8.6,-31.6,-8.6).curveTo(-34.5,-8.6,-36,-5.8).closePath().moveTo(-106.9,9.1).curveTo(-108.7,8.3,-110.1,6.8).curveTo(-111.4,5.4,-112,3.6).curveTo(-112.7,1.8,-112.7,-0).curveTo(-112.7,-1.9,-112,-3.7).curveTo(-111.4,-5.5,-110.1,-6.9).curveTo(-108.7,-8.4,-106.9,-9.1).curveTo(-105.2,-9.9,-103,-9.9).curveTo(-100.9,-9.9,-99.1,-9.1).curveTo(-97.4,-8.4,-96,-6.9).curveTo(-94.7,-5.5,-94,-3.7).curveTo(-93.4,-2.1,-93.4,-0).curveTo(-93.4,2,-94,3.6).curveTo(-94.7,5.4,-96,6.8).curveTo(-97.3,8.2,-99.1,9.1).curveTo(-101,9.8,-103,9.8).curveTo(-105.1,9.8,-106.9,9.1).closePath().moveTo(-107.5,-5.8).curveTo(-108.1,-4.4,-108.2,-3.7).curveTo(-108.5,-2.7,-108.6,-1.7).lineTo(-108.7,-0).curveTo(-108.7,1.7,-108.3,3.1).curveTo(-108,4.7,-107.3,5.9).curveTo(-106.7,7.1,-105.6,7.9).curveTo(-104.6,8.5,-103,8.5).curveTo(-101.5,8.5,-100.5,7.9).curveTo(-99.3,7.1,-98.7,5.9).curveTo(-98,4.7,-97.7,3.1).curveTo(-97.4,1.7,-97.4,-0).lineTo(-97.5,-1.7).curveTo(-97.6,-2.7,-97.8,-3.7).curveTo(-98.2,-4.9,-98.6,-5.8).curveTo(-100.1,-8.6,-103,-8.6).curveTo(-106,-8.6,-107.5,-5.8).closePath().moveTo(78.6,9.8).lineTo(67.6,-5.9).lineTo(67.6,8.3).lineTo(69.4,8.3).lineTo(69.4,9.6).lineTo(64.4,9.6).lineTo(64.4,8.3).lineTo(65,8.3).curveTo(65.4,8.3,65.7,8).curveTo(66.1,7.6,66.1,7.1).lineTo(66.1,-8.1).lineTo(65.9,-8.4).lineTo(64.4,-8.4).lineTo(64.4,-9.7).lineTo(69.4,-9.7).lineTo(78.5,3).lineTo(78.5,-8.4).lineTo(76.7,-8.4).lineTo(76.7,-9.7).lineTo(81.8,-9.7).lineTo(81.8,-8.4).curveTo(80.8,-8.4,80.4,-8).curveTo(80,-7.7,80,-7.1).lineTo(80,9.8).closePath().moveTo(24.3,9.8).lineTo(13.3,-5.9).lineTo(13.3,8.3).lineTo(15.1,8.3).lineTo(15.1,9.6).lineTo(10,9.6).lineTo(10,8.3).lineTo(10.7,8.3).curveTo(11.1,8.3,11.4,8).curveTo(11.8,7.5,11.8,7.1).lineTo(11.8,-8.1).lineTo(11.6,-8.4).lineTo(10,-8.4).lineTo(10,-9.7).lineTo(15.1,-9.7).lineTo(24.2,3).lineTo(24.2,-8.4).lineTo(22.4,-8.4).lineTo(22.4,-9.7).lineTo(27.5,-9.7).lineTo(27.5,-8.4).curveTo(26.5,-8.4,26.1,-8).curveTo(25.7,-7.6,25.7,-7.1).lineTo(25.7,9.8).closePath().moveTo(99.1,9.6).lineTo(99.1,8.3).lineTo(100.9,8.3).lineTo(100.9,-8.4).lineTo(99.1,-8.4).lineTo(99.1,-9.7).lineTo(113.2,-9.7).lineTo(113.2,-4).lineTo(111.7,-4).lineTo(111.7,-4.5).curveTo(111.3,-8.4,107.8,-8.4).lineTo(104.8,-8.4).lineTo(104.8,-1.2).lineTo(105,-1.2).curveTo(106.6,-1.2,107.2,-1.9).curveTo(107.9,-2.6,108,-4.3).lineTo(108,-4.9).lineTo(109.6,-4.9).lineTo(109.6,3.8).lineTo(108,3.8).lineTo(108,3.2).curveTo(107.9,1.5,107.2,0.9).curveTo(106.6,0.1,105,0.1).lineTo(104.8,0.1).lineTo(104.8,8.3).lineTo(108.8,8.3).curveTo(110.4,8.3,111.5,7.1).curveTo(112.5,5.8,112.7,2.9).lineTo(114.2,2.9).lineTo(114.2,9.6).closePath().moveTo(82.8,9.6).lineTo(82.8,8.3).lineTo(84.8,8.3).lineTo(84.8,-8.4).lineTo(82.8,-8.4).lineTo(82.8,-9.7).lineTo(89.6,-9.7).curveTo(93.3,-9.7,95.1,-8.4).curveTo(96.9,-7.2,96.9,-4.7).curveTo(96.6,-1.9,95.4,-1.3).curveTo(94.2,-0.6,96.1,0.1).curveTo(98.1,1.6,98.1,4).curveTo(98.1,6.6,96,8.1).curveTo(93.9,9.6,90.4,9.6).closePath().moveTo(88.7,-0).lineTo(88.7,8.3).lineTo(90.3,8.3).curveTo(91.6,8.3,92.2,8).curveTo(92.9,7.7,93.3,7.1).curveTo(93.6,6.6,93.8,5.7).curveTo(94,4.9,94,4).curveTo(94,2.2,93.2,1.1).curveTo(92.3,-0.1,90.3,-0.1).closePath().moveTo(88.7,-1.3).lineTo(89.7,-1.3).curveTo(90.8,-1.3,91.4,-1.6).curveTo(92,-1.9,92.4,-2.4).curveTo(92.7,-2.8,92.9,-3.5).curveTo(93,-4.1,93,-4.7).curveTo(93,-6.7,92.4,-7.4).curveTo(91.6,-8.4,89.6,-8.4).lineTo(88.7,-8.4).closePath().moveTo(48.3,9.6).lineTo(48.3,8.3).lineTo(50.1,8.3).lineTo(50.1,-8.4).lineTo(48.3,-8.4).lineTo(48.3,-9.7).lineTo(62.4,-9.7).lineTo(62.4,-4).lineTo(60.9,-4).lineTo(60.8,-4.5).curveTo(60.5,-8.4,57,-8.4).lineTo(54,-8.4).lineTo(54,-1.2).lineTo(54.2,-1.2).curveTo(55.8,-1.2,56.4,-1.9).curveTo(57.1,-2.7,57.2,-4.3).lineTo(57.2,-4.9).lineTo(58.7,-4.9).lineTo(58.7,3.8).lineTo(57.2,3.8).lineTo(57.2,3.2).curveTo(57.1,1.6,56.4,0.9).curveTo(55.8,0.1,54.2,0.1).lineTo(54,0.1).lineTo(54,8.3).lineTo(58,8.3).curveTo(59.6,8.3,60.6,7.1).curveTo(61.7,5.8,61.8,2.9).lineTo(63.3,2.9).lineTo(63.3,9.6).closePath().moveTo(28.5,9.6).lineTo(28.5,8.3).lineTo(30.5,8.3).lineTo(30.5,-8.4).lineTo(28.5,-8.4).lineTo(28.5,-9.7).lineTo(36.4,-9.7).curveTo(42.2,-9.7,45,-6.5).curveTo(46,-5.4,46.4,-4.3).curveTo(46.9,-3.2,47.1,-2).curveTo(47.3,-1.1,47.3,-0).curveTo(47.3,1,47.1,2).curveTo(46.9,3.1,46.4,4.2).curveTo(46,5.3,45,6.4).curveTo(42.2,9.6,36.4,9.6).closePath().moveTo(34.3,8.3).lineTo(36.4,8.3).curveTo(40.4,8.3,42.1,5.6).curveTo(43.2,3.6,43.2,-0).curveTo(43.2,-3.6,42.1,-5.6).curveTo(40.4,-8.4,36.4,-8.4).lineTo(34.3,-8.4).closePath().moveTo(1.5,9.6).lineTo(1.5,8.3).lineTo(3.3,8.3).lineTo(3.3,-8.4).lineTo(1.5,-8.4).lineTo(1.5,-9.7).lineTo(9,-9.7).lineTo(9,-8.4).lineTo(7.2,-8.4).lineTo(7.2,8.3).lineTo(9,8.3).lineTo(9,9.6).closePath().moveTo(-14.5,9.6).lineTo(-14.5,8.3).lineTo(-12.7,8.3).lineTo(-12.7,-8.4).lineTo(-14.5,-8.4).lineTo(-14.5,-9.7).lineTo(-7,-9.7).lineTo(-7,-8.4).lineTo(-8.9,-8.4).lineTo(-8.9,8.3).lineTo(-4.9,8.3).curveTo(-3.3,8.3,-2.2,7.1).curveTo(-1.2,5.8,-1,2.9).lineTo(0.5,2.9).lineTo(0.5,9.6).closePath().moveTo(-50,9.6).lineTo(-50,8.3).lineTo(-48.1,8.3).lineTo(-48.1,0.4).lineTo(-54.9,0.4).lineTo(-54.9,8.3).lineTo(-52.9,8.3).lineTo(-52.9,9.6).lineTo(-60.7,9.6).lineTo(-60.7,8.3).lineTo(-58.7,8.3).lineTo(-58.7,-8.4).lineTo(-60.7,-8.4).lineTo(-60.7,-9.7).lineTo(-52.9,-9.7).lineTo(-52.9,-8.4).lineTo(-54.9,-8.4).lineTo(-54.9,-0.9).lineTo(-48.1,-0.9).lineTo(-48.1,-8.4).lineTo(-50,-8.4).lineTo(-50,-9.7).lineTo(-42.3,-9.7).lineTo(-42.3,-8.4).lineTo(-44.2,-8.4).lineTo(-44.2,8.3).lineTo(-42.3,8.3).lineTo(-42.3,9.6).closePath().moveTo(-76.4,9.6).lineTo(-76.4,8.3).lineTo(-74.6,8.3).lineTo(-74.6,-8.4).lineTo(-76.4,-8.4).lineTo(-76.4,-9.7).lineTo(-69.4,-9.7).curveTo(-65.8,-9.7,-63.8,-8.2).curveTo(-61.7,-6.8,-61.7,-4.1).curveTo(-61.7,-1.5,-63.6,-0).curveTo(-65.5,1.4,-69,1.4).lineTo(-70.7,1.4).lineTo(-70.7,8.3).lineTo(-68.9,8.3).lineTo(-68.9,9.6).closePath().moveTo(-70.7,0.2).lineTo(-69,0.2).curveTo(-68.1,0.2,-67.3,-0.2).curveTo(-66.7,-0.5,-66.3,-1.1).curveTo(-65.9,-1.9,-65.9,-2.5).curveTo(-65.7,-3.3,-65.7,-4.1).lineTo(-65.9,-5.8).curveTo(-66,-6.6,-66.4,-7.1).curveTo(-66.8,-7.7,-67.5,-8).curveTo(-68.1,-8.4,-69.4,-8.4).lineTo(-70.7,-8.4).closePath().moveTo(-92.4,9.6).lineTo(-92.4,8.3).lineTo(-90.6,8.3).lineTo(-90.6,-8.4).lineTo(-92.4,-8.4).lineTo(-92.4,-9.7).lineTo(-84.9,-9.7).lineTo(-84.9,-8.4).lineTo(-86.7,-8.4).lineTo(-86.7,8.3).lineTo(-82.8,8.3).curveTo(-81.1,8.3,-80.1,7.1).curveTo(-79,5.8,-78.9,2.9).lineTo(-77.4,2.9).lineTo(-77.4,9.6).closePath().moveTo(-133,9.6).lineTo(-133,8.3).lineTo(-131,8.3).lineTo(-131,-8.4).lineTo(-133,-8.4).lineTo(-133,-9.7).lineTo(-125.1,-9.7).curveTo(-119.3,-9.7,-116.5,-6.5).curveTo(-115.5,-5.5,-115.1,-4.3).curveTo(-114.6,-3.3,-114.4,-2).lineTo(-114.2,-0).lineTo(-114.4,2).curveTo(-114.6,3.3,-115.1,4.2).curveTo(-115.6,5.4,-116.5,6.4).curveTo(-119.3,9.6,-125.1,9.6).closePath().moveTo(-127.1,8.3).lineTo(-125.1,8.3).curveTo(-121.1,8.3,-119.4,5.6).curveTo(-118.3,3.7,-118.3,-0).curveTo(-118.3,-3.8,-119.4,-5.6).curveTo(-121.1,-8.4,-125.1,-8.4).lineTo(-127.2,-8.4).closePath().moveTo(-141.7,9.6).lineTo(-141.7,8.3).lineTo(-140,8.3).lineTo(-141.8,3.4).lineTo(-147.3,3.4).lineTo(-149.1,8.3).lineTo(-147.7,8.3).lineTo(-147.7,9.6).lineTo(-152.3,9.6).lineTo(-152.3,8.3).curveTo(-151.2,8.3,-150.9,8.1).curveTo(-150.6,7.8,-150.4,7.4).lineTo(-144,-9.8).lineTo(-142.8,-9.8).lineTo(-135.8,8.3).lineTo(-134,8.3).lineTo(-134,9.6).closePath().moveTo(-142.3,2.1).lineTo(-144.6,-4).lineTo(-146.9,2.1).lineTo(-142.3,2.1).closePath();
	mask.setTransform(161.725,154.875);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#D3B485","#9A754D","#9D7851","#A5825D","#B29373","#C5AD94","#DED1C3","#FFFFFF","#FAF6F0","#EBDCC8","#D4B588","#D3B485","#D7B889","#D9BA8C"],[0,0.318,0.341,0.369,0.4,0.431,0.471,0.506,0.541,0.616,0.714,0.722,0.949,1],92.3,67.3,-178,-129.8).beginStroke().moveTo(-161.7,3).lineTo(-46.6,-154.9).lineTo(161.7,-3.1).lineTo(46.5,154.9).closePath();
	this.shape.setTransform(161.725,154.9);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_58, new cjs.Rectangle(9.5,145,304.5,19.80000000000001), null);


(lib.ClipGroup_57 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#A48057").beginStroke().moveTo(43.6,11.9).curveTo(41.9,11.2,40.3,9.7).curveTo(39.2,8.4,38.4,6.5).curveTo(37.8,4.7,37.7,2.8).curveTo(37.8,1,38.4,-0.9).curveTo(39.2,-2.6,40.3,-4).curveTo(41.8,-5.5,43.6,-6.3).curveTo(45.5,-7,47.4,-7.1).curveTo(49.4,-7,51.3,-6.3).curveTo(53.1,-5.5,54.5,-4).curveTo(55.8,-2.5,56.4,-0.9).curveTo(57.1,0.9,57.1,2.8).curveTo(57.1,4.8,56.4,6.5).curveTo(55.8,8.3,54.5,9.7).curveTo(53,11.2,51.3,11.9).curveTo(49.4,12.8,47.4,12.7).curveTo(45.5,12.8,43.6,11.9).closePath().moveTo(43,-2.9).curveTo(42.4,-1.7,42.2,-0.8).curveTo(42,0.1,41.9,1.2).lineTo(41.8,2.8).curveTo(41.8,4.6,42.1,6.1).curveTo(42.4,7.5,43.1,8.9).curveTo(43.9,10,44.9,10.7).curveTo(46,11.5,47.4,11.5).curveTo(48.9,11.5,50,10.7).curveTo(51.1,10,51.8,8.8).curveTo(52.4,7.5,52.7,6.1).curveTo(53.1,4.6,53.1,2.8).lineTo(53,1.2).curveTo(52.9,0.1,52.7,-0.8).curveTo(52.3,-2,51.8,-2.9).curveTo(50.3,-5.7,47.4,-5.7).curveTo(44.5,-5.7,43,-2.9).closePath().moveTo(13.2,9.7).curveTo(11.9,8.3,11.4,6.5).curveTo(10.7,4.9,10.7,2.8).curveTo(10.8,1,11.4,-0.9).curveTo(12.2,-2.6,13.3,-4).curveTo(14.6,-5.4,16.6,-6.3).curveTo(18.5,-7,20.4,-7.1).curveTo(21.3,-7,22.3,-6.8).lineTo(25.4,-6).lineTo(25.7,-6.1).lineTo(26,-6.6).lineTo(27.4,-6.6).lineTo(27.4,0).lineTo(25.9,0).lineTo(25.8,-0.4).lineTo(25.2,-2.4).curveTo(24.8,-3.3,24.1,-4).curveTo(23.5,-4.9,22.6,-5.3).curveTo(21.7,-5.8,20.4,-5.7).curveTo(17.5,-5.7,16,-2.9).curveTo(15.5,-2,15.2,-0.8).lineTo(14.9,1.2).lineTo(14.9,5.1).curveTo(15.1,6.4,15.4,7.4).curveTo(15.8,8.7,16.4,9.5).curveTo(17.1,10.4,18,10.9).curveTo(19,11.4,20.4,11.5).curveTo(21.9,11.4,22.9,11).curveTo(24,10.4,24.6,9.8).curveTo(25.4,9,25.7,8.2).curveTo(26.2,7.5,26.6,6.2).lineTo(28.2,6.6).lineTo(28.1,7.2).lineTo(27.5,8.3).lineTo(26.6,9.8).curveTo(26.1,10.6,25.2,11.2).curveTo(24.4,11.8,23.2,12.3).curveTo(22,12.8,20.4,12.7).curveTo(16.1,12.8,13.2,9.7).closePath().moveTo(29.3,12.5).lineTo(29.3,11.2).lineTo(31,11.2).lineTo(31,-5.5).lineTo(29.3,-5.5).lineTo(29.3,-6.7).lineTo(36.7,-6.7).lineTo(36.7,-5.5).lineTo(34.9,-5.5).lineTo(34.9,11.2).lineTo(36.7,11.2).lineTo(36.7,12.5).closePath().moveTo(2.3,12.5).lineTo(2.3,11.2).lineTo(4,11.2).lineTo(4,-5.5).lineTo(2.3,-5.5).lineTo(2.3,-6.7).lineTo(9.7,-6.7).lineTo(9.7,-5.5).lineTo(7.9,-5.5).lineTo(7.9,11.2).lineTo(9.7,11.2).lineTo(9.7,12.5).closePath().moveTo(-12.8,12.5).lineTo(-12.8,11.2).lineTo(-11,11.2).lineTo(-11,-5.5).lineTo(-12.8,-5.5).lineTo(-12.8,-6.7).lineTo(1.2,-6.7).lineTo(1.2,-1).lineTo(-0.3,-1).lineTo(-0.3,-1.6).curveTo(-0.7,-5.5,-4.1,-5.5).lineTo(-7.1,-5.5).lineTo(-7.1,2.2).lineTo(-6.9,2.2).curveTo(-5.4,2.2,-4.7,1.5).curveTo(-4,0.7,-4,-0.9).lineTo(-3.9,-1.5).lineTo(-2.4,-1.5).lineTo(-2.4,7.2).lineTo(-3.9,7.2).lineTo(-4,6.6).curveTo(-4,4.9,-4.7,4.3).curveTo(-5.4,3.5,-6.9,3.5).lineTo(-7.1,3.5).lineTo(-7.1,11.2).lineTo(-4.8,11.2).lineTo(-4.8,12.5).closePath().moveTo(-21.2,12.5).lineTo(-21.2,11.2).lineTo(-19.4,11.2).lineTo(-19.4,-5.5).lineTo(-21.2,-5.5).lineTo(-21.2,-6.7).lineTo(-13.8,-6.7).lineTo(-13.8,-5.5).lineTo(-15.6,-5.5).lineTo(-15.6,11.2).lineTo(-13.8,11.2).lineTo(-13.8,12.5).closePath().moveTo(-41,12.5).lineTo(-41,11.2).lineTo(-39.1,11.2).lineTo(-39.1,-5.5).lineTo(-41,-5.5).lineTo(-41,-6.7).lineTo(-33.1,-6.7).curveTo(-27.3,-6.7,-24.5,-3.6).curveTo(-23.5,-2.4,-23.1,-1.4).curveTo(-22.6,-0.3,-22.5,0.8).lineTo(-22.2,2.8).lineTo(-22.5,4.8).curveTo(-22.6,6.1,-23.1,7.1).curveTo(-23.5,8.1,-24.5,9.3).curveTo(-27.3,12.4,-33.1,12.5).closePath().moveTo(-35.2,11.2).lineTo(-33.1,11.2).curveTo(-29.2,11.2,-27.5,8.4).curveTo(-26.3,6.5,-26.3,2.8).curveTo(-26.3,-0.8,-27.5,-2.8).curveTo(-29.2,-5.5,-33.1,-5.5).lineTo(-35.2,-5.5).closePath().moveTo(-57.1,12.5).lineTo(-57.1,11.2).lineTo(-55.3,11.2).lineTo(-55.3,-5.5).lineTo(-57.1,-5.5).lineTo(-57.1,-6.7).lineTo(-43,-6.7).lineTo(-43,-1).lineTo(-44.5,-1).lineTo(-44.5,-1.6).curveTo(-44.8,-5.5,-48.4,-5.5).lineTo(-51.4,-5.5).lineTo(-51.4,1.7).lineTo(-51.1,1.7).curveTo(-49.6,1.7,-49,0.9).curveTo(-48.2,0.2,-48.2,-1.5).lineTo(-48.1,-2).lineTo(-46.6,-2).lineTo(-46.6,6.6).lineTo(-48.1,6.6).lineTo(-48.2,6.1).curveTo(-48.2,4.5,-49,3.7).curveTo(-49.6,3,-51.1,3).lineTo(-51.4,3).lineTo(-51.4,11.2).lineTo(-47.4,11.2).curveTo(-45.8,11.2,-44.7,9.9).curveTo(-43.7,8.8,-43.6,5.7).lineTo(-42,5.7).lineTo(-42,12.5).closePath().moveTo(4.1,-7.8).lineTo(6.3,-11.7).curveTo(6.8,-12.5,7.6,-12.7).lineTo(7.8,-12.7).curveTo(8.3,-12.7,8.7,-12.4).curveTo(9.1,-12.1,9.2,-11.6).curveTo(9.2,-11.1,8.6,-10.2).lineTo(5.1,-7.1).closePath();
	this.shape.setTransform(69.2,67.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_57, new cjs.Rectangle(12.1,54.4,114.2,25.500000000000007), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.bgMenu = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#240E0E","#4C1018"],[0,1],-960,0,960,0).beginStroke().moveTo(-960,16).lineTo(-960,-16).lineTo(960,-16).lineTo(960,16).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bgMenu, new cjs.Rectangle(-960,-16,1920,32), null);


(lib.go_back = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.instance = new lib.button();
	this.instance.setTransform(20.25,40.25,0.3126,0.6252,0,0,0,0.8,0.4);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text
	this.instance_1 = new lib.CachedBmp_29();
	this.instance_1.setTransform(8.5,21.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,40).lineTo(-20,-40).lineTo(20,-40).lineTo(20,40).closePath();
	this.shape.setTransform(20,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.go_back, new cjs.Rectangle(0,0,40,80), null);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1043.55,13.25);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1325.7,13.25);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(1428.15,13.25);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(671.25,13.25);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1163.55,13.25);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(839.4,13.25);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(516.8,13.25);

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(352.65,13.25);

	this.instance_8 = new lib.vertical();
	this.instance_8.setTransform(196.8,13.25);

	this.instance_9 = new lib.vertical();
	this.instance_9.setTransform(79.65,13.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_10 = new lib.square();
	this.instance_10.setTransform(4,4);
	this.instance_10.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// ball
	this.instance_11 = new lib.ball();
	this.instance_11.setTransform(76.5,14);
	this.instance_11.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	// title
	this.instance_12 = new lib.CachedBmp_28();
	this.instance_12.setTransform(871.05,1,0.5,0.5);

	this.instance_13 = new lib.CachedBmp_27();
	this.instance_13.setTransform(1457.1,1,0.5,0.5);

	this.instance_14 = new lib.CachedBmp_26();
	this.instance_14.setTransform(6.2,1,0.5,0.5);

	this.instance_15 = new lib.CachedBmp_25();
	this.instance_15.setTransform(108.6,1,0.5,0.5);

	this.instance_16 = new lib.CachedBmp_24();
	this.instance_16.setTransform(225.8,1,0.5,0.5);

	this.instance_17 = new lib.CachedBmp_23();
	this.instance_17.setTransform(381.6,1,0.5,0.5);

	this.instance_18 = new lib.CachedBmp_22();
	this.instance_18.setTransform(545.8,1,0.5,0.5);

	this.instance_19 = new lib.CachedBmp_21();
	this.instance_19.setTransform(700.2,1,0.5,0.5);

	this.instance_20 = new lib.CachedBmp_20();
	this.instance_20.setTransform(1068.4,1,0.5,0.5);

	this.instance_21 = new lib.CachedBmp_19();
	this.instance_21.setTransform(1192.5,1,0.5,0.5);

	this.instance_22 = new lib.CachedBmp_18();
	this.instance_22.setTransform(1354.7,1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1508.6,25.5), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:0},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.instance_3 = new lib.bgMenu();
	this.instance_3.setTransform(960,41.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-1,-2,1922,63), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// flash0_ai
	this.instance = new lib.ClipGroup_57();
	this.instance.setTransform(112.7,-16.75,0.7405,0.7405,0,0,0,69.3,67.2);

	this.instance_1 = new lib.ClipGroup_58();
	this.instance_1.setTransform(112.7,11.5,0.7405,0.7405,0,0,0,161.4,154.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1,p:{regX:161.4}},{t:this.instance}]},2).to({state:[{t:this.instance_1,p:{regX:161.4}},{t:this.instance}]},1).to({state:[{t:this.instance_1,p:{regX:161.6}},{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-103.2,239.6,229.4);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.instance = new lib.bgCapa();
	this.instance.setTransform(-4,-60,1.1914,1.1914);

	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FCF7F0").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(961.25,540.15);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_1.setTransform(961.25,540.15);

	this.instance_1 = new lib.Bitmap2();
	this.instance_1.setTransform(0,0,1.1852,1.1852);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginLinearGradientFill(["#FFFFFF","#999999"],[0,1],440.1,-191.8,1237.5,202.6).beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_2.setTransform(961.25,540.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_2}]},1).wait(2));

	// size
	this.instance_2 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-60,1930.1,1270.1);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:147.65},0).wait(1).to({x:290.2},0).wait(1).to({x:468.05},0).wait(1).to({x:644.85},0).wait(1).to({x:812.8},0).wait(1).to({x:988.35},0).wait(1).to({x:1158.1},0).wait(1).to({x:1299.9},0).wait(1).to({x:1454.6},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1477.2,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		// const gotoPage = (event, {url}) => {
		//     /**
		//      * Go back page for portal.
		//      */
		//     window.open(url, '_self');
		// }
		//
		// this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		// this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage, false, false, {url: 'http://portal-terra-web.local'});
		    
		const gotoPage = () => {
		    /**
		     * Close page with extension plugin chrome.
		     */
			//chrome.runtime.sendMessage('maglcmgfenlbeehaeohfbkncflcafmko', {action: 'closeBrowser'});
		    /**
		     * Close page with window browser.
		     */
			window.close();
		}
		
		this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// go_back
	this.btn_go_back = new lib.go_back();
	this.btn_go_back.name = "btn_go_back";
	this.btn_go_back.setTransform(1879.95,1000);
	this.btn_go_back.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.btn_go_back).wait(1));

	// button
	this.btn_page13 = new lib.button();
	this.btn_page13.name = "btn_page13";
	this.btn_page13.setTransform(1788,1039.05,0.4515,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page13, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1247.1,1039.05,1.32,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1062.25,1039.05,1.0238,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1078.2,1117.8,0.8908,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1682,1039.05,0.4515,0.4688,0,0,0,0.6,0.1);
	this.btn_page12.visible = false;
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1547.4,1039.05,0.9651,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1405.8,1039.05,0.6039,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(899.7,1039.05,1.166,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(741.9,1039.05,1.0158,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(578.65,1039.05,0.9646,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(441.45,1039.05,0.653,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(333.85,1039.05,0.4445,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page13}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(155.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(283.45,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(329.8,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1074.15,1087.75);
	this.instance.visible = false;

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1730.1,1087,1.1053,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_2 = new lib.title();
	this.instance_2.setTransform(305.7,1027);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// logo
	this.occ_logo = new lib.logo_1();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(45.65,1029.45);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_3 = new lib.background();
	this.instance_3.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-1,0,1922,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// Model
	this.instance = new lib.zoom_brack();
	this.instance.setTransform(16.8,-40.9,1,1,0,0,0,0.3,0.3);

	this.instance_1 = new lib.zoom_white();
	this.instance_1.setTransform(102.35,-40.9,1,1,0,0,0,0.3,0.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[]},1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.instance_2 = new lib.CachedBmp_17();
	this.instance_2.setTransform(-287.7,1095.95,0.5,0.5);

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02},{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(672.3,480.6,1248.7,901.9);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png?1786114144016", id:"index_atlas_1"},
		{src:"./images/index_atlas_2.png?1786114144016", id:"index_atlas_2"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
 